var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-container grid-component" },
    [
      _c("q-table", {
        staticClass: "scroll",
        attrs: {
          "row-key": "__index",
          color: "secondary",
          selection: _vm.selectable,
          selected: _vm.selected,
          data: _vm.data,
          columns: _vm.columnOptions,
          loading: _vm.loading,
          filter: _vm.filter,
          "visible-columns":
            _vm.columnsModel.length > 0 ? _vm.columnsModel : null,
          "hide-bottom": _vm.hideFooter,
          pagination: _vm.paginationOptions,
          "rows-per-page-options": _vm.rowsPerPageOptions
        },
        on: {
          "update:selected": function($event) {
            _vm.selected = $event
          },
          request: _vm.request,
          "update:pagination": function($event) {
            _vm.paginationOptions = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "top",
            fn: function(props) {
              return !_vm.hideHeader
                ? _c(
                    "div",
                    { staticClass: "row fit" },
                    [
                      _vm.columnsModel.length > 0 && !_vm.hideShowColumns
                        ? _c("q-select", {
                            staticClass: "q-mx-md show-column",
                            attrs: {
                              multiple: "",
                              toggle: "",
                              "float-label": "Show Columns",
                              "display-value": _vm.columnSelectText,
                              options: _vm.visibleColumnsOptions
                            },
                            model: {
                              value: _vm.columnsModel,
                              callback: function($$v) {
                                _vm.columnsModel = $$v
                              },
                              expression: "columnsModel"
                            }
                          })
                        : _vm._e(),
                      _vm._t("header-left", null, { slotScope: "props" }),
                      props.pagination.rowsNumber && !_vm.hideCount
                        ? _c(
                            "div",
                            { staticClass: "header-row-count absolute-center" },
                            [
                              _vm._v(
                                _vm._s(props.pagination.rowsNumber) +
                                  " record" +
                                  _vm._s(
                                    _vm.pluralWording(
                                      props.pagination.rowsNumber
                                    )
                                  ) +
                                  " total"
                              )
                            ]
                          )
                        : _vm._e(),
                      !props.pagination.rowsNumber && !_vm.hideCount
                        ? _c(
                            "div",
                            { staticClass: "header-row-count absolute-center" },
                            [
                              _vm._v(
                                _vm._s(_vm.data.length) +
                                  " record" +
                                  _vm._s(_vm.pluralWording(_vm.data.length)) +
                                  " found"
                              )
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "pull-right" },
                        [
                          _vm.onRequest
                            ? _c(
                                "q-btn",
                                {
                                  ref: "gridRefresh",
                                  staticStyle: { "margin-right": "5px" },
                                  attrs: {
                                    outline: "",
                                    rounded: "",
                                    color: "grey",
                                    icon: "fa fa-refresh",
                                    align: "left"
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.request(props)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "q-tooltip",
                                    {
                                      attrs: {
                                        anchor: "bottom middle",
                                        self: "top middle",
                                        offset: [10, 10]
                                      }
                                    },
                                    [_vm._v("Refresh Grid")]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.onExport
                            ? _c(
                                "q-btn-dropdown",
                                {
                                  attrs: {
                                    outline: "",
                                    rounded: "",
                                    align: "left",
                                    color: "green",
                                    icon: "fa fa-cloud-download"
                                  }
                                },
                                [
                                  _c(
                                    "q-list",
                                    { attrs: { link: "" } },
                                    [
                                      _c(
                                        "q-item",
                                        {
                                          directives: [
                                            {
                                              name: "close-overlay",
                                              rawName: "v-close-overlay"
                                            }
                                          ],
                                          nativeOn: {
                                            click: function($event) {
                                              _vm.exportGrid(props, "page")
                                            }
                                          }
                                        },
                                        [
                                          _c("q-item-main", [
                                            _vm._v(
                                              "\n                Export Page\n              "
                                            )
                                          ])
                                        ],
                                        1
                                      ),
                                      _c(
                                        "q-item",
                                        {
                                          directives: [
                                            {
                                              name: "close-overlay",
                                              rawName: "v-close-overlay"
                                            }
                                          ],
                                          nativeOn: {
                                            click: function($event) {
                                              _vm.exportGrid(props, "all")
                                            }
                                          }
                                        },
                                        [
                                          _c("q-item-main", [
                                            _vm._v(
                                              "\n                Export All\n              "
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    2
                  )
                : _vm._e()
            }
          },
          {
            key: "header",
            fn: function(props) {
              return _c(
                "q-tr",
                {},
                [
                  _vm.expandable || (_vm.selectable && _vm.selectable != "none")
                    ? _c(
                        "q-th",
                        { attrs: { "auto-width": "" } },
                        [
                          props.multipleSelect && !_vm.hideSelectAll
                            ? _c("q-checkbox", {
                                staticClass: "select-all",
                                attrs: { "indeterminate-value": "some" },
                                nativeOn: {
                                  click: function($event) {
                                    _vm.select(_vm.selected, props.index)
                                  }
                                },
                                model: {
                                  value: props.selected,
                                  callback: function($$v) {
                                    _vm.$set(props, "selected", $$v)
                                  },
                                  expression: "props.selected"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.onLaunch || _vm.onDownload || _vm.onPrint
                    ? _c(
                        "q-th",
                        {
                          staticClass:
                            "no-padding relative-position text-center",
                          attrs: { "auto-width": "" }
                        },
                        [
                          _c("q-icon", {
                            staticStyle: { position: "static !important" },
                            attrs: { name: "fa fa-ellipsis-v", size: "25px" }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._l(props.cols, function(col) {
                    return _c(
                      "q-th",
                      { key: col.name, attrs: { props: props } },
                      [
                        _c(
                          "div",
                          { style: { width: col.width || null } },
                          [
                            _vm._t("header-item", [_vm._v(_vm._s(col.label))], {
                              col: col,
                              label: col.label
                            }),
                            col.filter
                              ? _c(
                                  "q-btn",
                                  {
                                    staticClass: "filterBtn",
                                    attrs: { icon: "fa fa-filter", size: "sm" },
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                      }
                                    }
                                  },
                                  [
                                    col.type === "date"
                                      ? _c(
                                          "q-popover",
                                          {
                                            staticClass: "q-pa-md filter",
                                            attrs: {
                                              anchor: "bottom right",
                                              offset: [-300, 0]
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "row justify-between"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "col-5" },
                                                  [
                                                    _c("q-datetime", {
                                                      attrs: {
                                                        type: "date",
                                                        "float-label":
                                                          "Start Date",
                                                        format:
                                                          _vm.formats.date,
                                                        clearable: true
                                                      },
                                                      on: {
                                                        clear: function(
                                                          $event
                                                        ) {
                                                          _vm.onFilterClear()
                                                        },
                                                        change: function(
                                                          $event
                                                        ) {
                                                          _vm.triggerRequest(
                                                            col.filter.start
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value: col.filter.start,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            col.filter,
                                                            "start",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "col.filter.start"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "div",
                                                  [
                                                    _c("q-icon", {
                                                      staticClass:
                                                        "col-2 vertical-middle q-mt-md",
                                                      attrs: {
                                                        name: "fa fa-minus",
                                                        size: "1.0rem"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "div",
                                                  { staticClass: "col-5" },
                                                  [
                                                    _c("q-datetime", {
                                                      attrs: {
                                                        type: "date",
                                                        "float-label":
                                                          "End Date",
                                                        format:
                                                          _vm.formats.date,
                                                        clearable: true
                                                      },
                                                      on: {
                                                        clear: function(
                                                          $event
                                                        ) {
                                                          _vm.onFilterClear()
                                                        },
                                                        change: function(
                                                          $event
                                                        ) {
                                                          _vm.triggerRequest(
                                                            col.filter.end
                                                          )
                                                        }
                                                      },
                                                      model: {
                                                        value: col.filter.end,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            col.filter,
                                                            "end",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "col.filter.end"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    col.type === "number"
                                      ? _c(
                                          "q-popover",
                                          {
                                            staticClass: "q-pa-md filter",
                                            attrs: {
                                              anchor: "bottom right",
                                              offset: [-300, 0]
                                            }
                                          },
                                          [
                                            col.type === "number"
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "row justify-between"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "col-5" },
                                                      [
                                                        _c("q-input", {
                                                          attrs: {
                                                            align: "left",
                                                            type: "number",
                                                            "float-label":
                                                              "Minimum",
                                                            clearable: true
                                                          },
                                                          on: {
                                                            clear: function(
                                                              $event
                                                            ) {
                                                              _vm.onFilterClear()
                                                            },
                                                            keyup: function(
                                                              $event
                                                            ) {
                                                              if (
                                                                !(
                                                                  "button" in
                                                                  $event
                                                                ) &&
                                                                _vm._k(
                                                                  $event.keyCode,
                                                                  "enter",
                                                                  13,
                                                                  $event.key,
                                                                  "Enter"
                                                                )
                                                              ) {
                                                                return null
                                                              }
                                                              _vm.triggerRequest(
                                                                col.filter.min
                                                              )
                                                            }
                                                          },
                                                          model: {
                                                            value:
                                                              col.filter.min,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                col.filter,
                                                                "min",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "col.filter.min"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "div",
                                                      [
                                                        _c("q-icon", {
                                                          staticClass:
                                                            "col-2 vertical-middle q-mt-md",
                                                          attrs: {
                                                            name: "fa fa-minus",
                                                            size: "1.0rem"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "div",
                                                      { staticClass: "col-5" },
                                                      [
                                                        _c("q-input", {
                                                          attrs: {
                                                            align: "left",
                                                            type: "number",
                                                            "float-label":
                                                              "Maximum",
                                                            clearable: true
                                                          },
                                                          on: {
                                                            clear: function(
                                                              $event
                                                            ) {
                                                              _vm.onFilterClear()
                                                            },
                                                            keyup: function(
                                                              $event
                                                            ) {
                                                              if (
                                                                !(
                                                                  "button" in
                                                                  $event
                                                                ) &&
                                                                _vm._k(
                                                                  $event.keyCode,
                                                                  "enter",
                                                                  13,
                                                                  $event.key,
                                                                  "Enter"
                                                                )
                                                              ) {
                                                                return null
                                                              }
                                                              _vm.triggerRequest(
                                                                col.filter.max
                                                              )
                                                            }
                                                          },
                                                          model: {
                                                            value:
                                                              col.filter.max,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                col.filter,
                                                                "max",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "col.filter.max"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      : _vm._e(),
                                    col.type === "string"
                                      ? _c(
                                          "q-popover",
                                          {
                                            staticClass: "q-pa-md filter",
                                            attrs: {
                                              anchor: "bottom right",
                                              offset: [-300, 0]
                                            }
                                          },
                                          [
                                            col.type === "string"
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "row justify-between"
                                                  },
                                                  [
                                                    col.type === "string"
                                                      ? _c("q-input", {
                                                          staticClass:
                                                            "full-width",
                                                          attrs: {
                                                            align: "left",
                                                            "float-label":
                                                              "Search by",
                                                            disable:
                                                              !col.filterable ||
                                                              false,
                                                            clearable: true
                                                          },
                                                          on: {
                                                            clear: function(
                                                              $event
                                                            ) {
                                                              _vm.onFilterClear()
                                                            },
                                                            keyup: function(
                                                              $event
                                                            ) {
                                                              if (
                                                                !(
                                                                  "button" in
                                                                  $event
                                                                ) &&
                                                                _vm._k(
                                                                  $event.keyCode,
                                                                  "enter",
                                                                  13,
                                                                  $event.key,
                                                                  "Enter"
                                                                )
                                                              ) {
                                                                return null
                                                              }
                                                              _vm.triggerRequest(
                                                                col.filter
                                                              )
                                                            }
                                                          },
                                                          model: {
                                                            value: col.filter,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                col,
                                                                "filter",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "col.filter"
                                                          }
                                                        })
                                                      : _vm._e()
                                                  ],
                                                  1
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      : _vm._e(),
                                    col.type === "state"
                                      ? _c(
                                          "q-popover",
                                          {
                                            staticClass: "q-pa-md filter",
                                            attrs: {
                                              anchor: "bottom right",
                                              offset: [-300, 0]
                                            }
                                          },
                                          [
                                            col.type === "state"
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "row justify-between"
                                                  },
                                                  [
                                                    col.type === "state"
                                                      ? _c("q-select", {
                                                          staticClass:
                                                            "full-width",
                                                          attrs: {
                                                            align: "left",
                                                            "float-label":
                                                              "State",
                                                            options:
                                                              _vm.stateOptions,
                                                            disable: !col.filterable,
                                                            clearable: true
                                                          },
                                                          on: {
                                                            clear: function(
                                                              $event
                                                            ) {
                                                              _vm.onFilterClear()
                                                            },
                                                            input: function(
                                                              $event
                                                            ) {
                                                              _vm.triggerRequest(
                                                                col.filter
                                                              )
                                                            }
                                                          },
                                                          model: {
                                                            value: col.filter,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                col,
                                                                "filter",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "col.filter"
                                                          }
                                                        })
                                                      : _vm._e()
                                                  ],
                                                  1
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      : _vm._e(),
                                    col.type === "boolean"
                                      ? _c(
                                          "q-popover",
                                          {
                                            staticClass: "q-pa-md filter",
                                            attrs: {
                                              anchor: "bottom right",
                                              offset: [-300, 0]
                                            }
                                          },
                                          [
                                            col.type === "boolean"
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "row justify-between"
                                                  },
                                                  [
                                                    col.type === "boolean"
                                                      ? _c("q-select", {
                                                          staticClass:
                                                            "full-width",
                                                          attrs: {
                                                            align: "left",
                                                            "float-label":
                                                              "True or False",
                                                            options:
                                                              _vm.booleanOptions,
                                                            disable: !col.filterable,
                                                            clearable: true
                                                          },
                                                          on: {
                                                            clear: function(
                                                              $event
                                                            ) {
                                                              _vm.onFilterClear()
                                                            },
                                                            input: function(
                                                              $event
                                                            ) {
                                                              _vm.triggerRequest(
                                                                col.filter
                                                              )
                                                            }
                                                          },
                                                          model: {
                                                            value: col.filter,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                col,
                                                                "filter",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "col.filter"
                                                          }
                                                        })
                                                      : _vm._e()
                                                  ],
                                                  1
                                                )
                                              : _vm._e()
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          2
                        )
                      ]
                    )
                  })
                ],
                2
              )
            }
          },
          {
            key: "body",
            fn: function(props) {
              return [
                _c(
                  "q-tr",
                  {
                    class: { exception: _vm.exceptionMap[props.key] },
                    attrs: { props: props }
                  },
                  [
                    _vm.expandable ||
                    (_vm.selectable && _vm.selectable != "none")
                      ? _c(
                          "q-td",
                          [
                            _vm.expandable
                              ? _c("q-checkbox", {
                                  staticClass: "q-mr-md",
                                  attrs: {
                                    color: "primary",
                                    "checked-icon": "expand_less",
                                    "unchecked-icon": "expand_more",
                                    title: "Expand"
                                  },
                                  nativeOn: {
                                    click: function($event) {
                                      typeof _vm.onExpand == "function"
                                        ? _vm.onExpand({
                                            props: props,
                                            row: props.row,
                                            expanded: props.row.expand
                                          })
                                        : ""
                                    }
                                  },
                                  model: {
                                    value: props.row.expand,
                                    callback: function($$v) {
                                      _vm.$set(props.row, "expand", $$v)
                                    },
                                    expression: "props.row.expand"
                                  }
                                })
                              : _vm._e(),
                            _vm.selectable
                              ? _c("q-checkbox", {
                                  attrs: { color: "primary" },
                                  nativeOn: {
                                    click: function($event) {
                                      _vm.select(_vm.selected)
                                    }
                                  },
                                  model: {
                                    value: props.selected,
                                    callback: function($$v) {
                                      _vm.$set(props, "selected", $$v)
                                    },
                                    expression: "props.selected"
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.onLaunch || _vm.onDownload
                      ? _c(
                          "q-td",
                          {
                            staticClass: "row-actions",
                            staticStyle: { "min-width": "85px" },
                            attrs: { "auto-width": "" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                              }
                            }
                          },
                          [
                            _vm.onLaunch
                              ? _c(
                                  "q-btn",
                                  {
                                    attrs: {
                                      icon: "fa fa-external-link",
                                      outline: "",
                                      color: "primary"
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.onLaunch(props.row)
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "q-tooltip",
                                      {
                                        attrs: {
                                          anchor: "bottom middle",
                                          self: "top middle",
                                          offset: [10, 10]
                                        }
                                      },
                                      [_vm._v("View")]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.onDownload
                              ? _c(
                                  "q-btn",
                                  {
                                    attrs: {
                                      icon: "fa fa-download",
                                      outline: "",
                                      color: "primary"
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.onDownload(props.row)
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "q-tooltip",
                                      {
                                        attrs: {
                                          anchor: "bottom middle",
                                          self: "top middle",
                                          offset: [10, 10]
                                        }
                                      },
                                      [_vm._v("Download")]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.onRead &&
                            _vm.shouldShowRead &&
                            _vm.shouldShowRead(props.row)
                              ? _c(
                                  "q-btn",
                                  {
                                    staticStyle: { "margin-left": "0.5em" },
                                    attrs: {
                                      icon: "fa fa-book",
                                      outline: "",
                                      color: "purple"
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.onRead(props.row)
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "q-tooltip",
                                      {
                                        attrs: {
                                          anchor: "bottom middle",
                                          self: "top middle",
                                          offset: [10, 10]
                                        }
                                      },
                                      [_vm._v("Read Document")]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.onPrint
                              ? _c(
                                  "q-btn",
                                  {
                                    staticStyle: { "margin-left": "0.3em" },
                                    attrs: {
                                      icon: "fa fa-print",
                                      outline: "",
                                      color: "purple"
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.onPrint(props.row)
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "q-tooltip",
                                      {
                                        attrs: {
                                          anchor: "bottom middle",
                                          self: "top middle",
                                          offset: [10, 10]
                                        }
                                      },
                                      [_vm._v("Print")]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._l(props.cols, function(col) {
                      return _c(
                        "q-td",
                        { key: col.name, attrs: { props: props } },
                        [
                          _c(
                            "div",
                            {
                              class: { "clickable-col": col.clickable },
                              style: { width: col.width || null },
                              on: {
                                click: function($event) {
                                  col.clickable
                                    ? _vm.handleColumnClick(props.row, col)
                                    : null
                                }
                              }
                            },
                            [
                              _vm._t(
                                "col-item-" + col.name.toLowerCase(),
                                [
                                  col.label != "Date Issued" &&
                                  col.label != "Date of Birth"
                                    ? _c("div", [_vm._v(_vm._s(col.value))])
                                    : _vm._e(),
                                  col.label == "Date of Birth"
                                    ? _c("div", [
                                        _vm._v(
                                          _vm._s(
                                            col.value
                                              ? _vm.formattedDate(
                                                  new Date(col.value)
                                                )
                                              : "NA"
                                          )
                                        )
                                      ])
                                    : _vm._e(),
                                  col.label == "Date Issued"
                                    ? _c("div", [
                                        _vm._v(
                                          _vm._s(
                                            col.value
                                              ? _vm.formattedDate(
                                                  new Date(col.value)
                                                )
                                              : "NA"
                                          )
                                        )
                                      ])
                                    : _vm._e()
                                ],
                                { col: col, value: col.value, index: props.key }
                              )
                            ],
                            2
                          )
                        ]
                      )
                    }),
                    _vm.onDelete !== undefined && _vm.canDelete()
                      ? _c(
                          "q-td",
                          [
                            _c(
                              "q-btn",
                              {
                                staticClass: "delete-icon",
                                attrs: {
                                  round: "",
                                  outline: "",
                                  color: "red",
                                  icon: "delete"
                                },
                                on: {
                                  click: function($event) {
                                    _vm.onDelete(props.row)
                                  }
                                }
                              },
                              [
                                _c(
                                  "q-tooltip",
                                  {
                                    attrs: {
                                      anchor: "bottom middle",
                                      self: "top middle",
                                      offset: [10, 10]
                                    }
                                  },
                                  [_vm._v("Delete")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  2
                ),
                props.row.expand
                  ? _c(
                      "q-tr",
                      {
                        staticClass: "expandable-row",
                        attrs: { props: props }
                      },
                      [
                        _c(
                          "q-td",
                          { attrs: { colspan: "100%" } },
                          [_vm._t("col-item-expand", null, { props: props })],
                          2
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]
            }
          },
          {
            key: "pagination",
            fn: function(props) {
              return [
                _c(
                  "div",
                  { staticClass: "text-center row flex-center q-py-sm" },
                  [
                    props.pagesNumber != Infinity
                      ? _c("q-pagination", {
                          attrs: {
                            value: props.pagination.page,
                            color: "primary",
                            max: props.pagesNumber,
                            ellipses: true,
                            "max-pages": 6,
                            "direction-links": "",
                            "boundary-links": ""
                          },
                          on: {
                            change: function(val) {
                              return _vm.changePage(val)
                            }
                          }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }